// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum SALE_NEGOTIATION_ITEM_STATUS_TYPE {
    initiated = 'initiated',
    offerSubmitted = 'offer-submitted',
    negotiation = 'negotiation',
    agreement = 'agreement',
    orderPlaced = 'order-placed',
    denied = 'denied',
}
